import React from "react";
import styles from "./index.module.css";

const Head = ({ children }) => {
  return <div className={styles["head"]}>{children}</div>;
};

const Row = ({ children, islast }) => {
  return (
    <div className={styles["row"] + " " + `${islast && styles["lastRow"]}`}>
      {children}
    </div>
  );
};

export { Head, Row };
